import { render, staticRenderFns } from "./WHome.vue?vue&type=template&id=0fa140bf&scoped=true"
import script from "./WHome.vue?vue&type=script&lang=js"
export * from "./WHome.vue?vue&type=script&lang=js"
import style0 from "./WHome.vue?vue&type=style&index=0&id=0fa140bf&prod&lang=css"
import style1 from "./WHome.vue?vue&type=style&index=1&id=0fa140bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa140bf",
  null
  
)

export default component.exports